<script>
import formatDate from '@utils/format-date'
import DialogApplicableEvents from '@components/Dialog/ApplicableEvents'
import { couponDateRange } from '@utils/zerone-coupon'

export default {
  components: {
    DialogApplicableEvents,
  },
  filters: {
    formatDate,
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          title: '一般上課券',
          code: 'ZERONE_R8KW4',
          startDate: '2021-10-27 13:57:36',
          endDate: null,
          discountType: null,
          discountValue: 0,
          applicableEvents: [
            {
              title: 'adasd',
              alias: 'v1fapmkfxkhqcrlg',
              categoryTitle: '活動',
              type: 'online',
              dateType: 'single',
              registrationType: 'impartial',
              registrationStartDate: '2021-10-01 00:00:00',
              registrationEndDate: '2021-12-04 00:00:00',
              canRegisterGroup: 7,
              inProgress: 0,
              canApply: 1,
              seriesNum: '4QINK',
              brands: [
                {
                  title: 'VMware',
                  alias: 'vmware',
                  logo: null,
                  contact: [],
                },
              ],
              dateTimeRange: '2021/10/30(六) (08:00-11:00)',
            },
          ],
        }
      },
    },
  },
  data() {
    return {
      isDialogApplicableEventsVisible: false,
      dialogApplicableEventList: [],
    }
  },
  methods: {
    couponDateRange,
    openDialogCourse(item) {
      this.isDialogApplicableEventsVisible = true
      this.dialogApplicableEventList = this.item.applicableEvents ?? []
      // this.currentList = [item]
    },
  },
}
</script>
<template>
  <div :class="$style.memberCouponItem">
    <div class="row">
      <div class="col-md-8">
        <div class="d-flex justify-content-between">
          <p class="text-base md:text-2xl mb-0 pr-md-0 pr-2">{{ item.title }}</p>
          <BaseButton class="isStylePrimary isText memberCouponItem__Btn py-1 d-md-none" @click="openDialogCourse(item)"> 查看適用項目 <i class="fal fa-chevron-right"></i> </BaseButton>
        </div>
        <div class="text-gray-5 text-sm md:text-base mt-2">{{ item.code }}</div>
        <div class="text-2sm md:text-sm color-gray-5 mt-5"> 有效日期：{{ couponDateRange({ ...item }) }} </div>
      </div>
      <div class="col-md-4 mt-md-0 mt-4 align-self-center d-md-block d-none">
        <BaseButton class="isStylePrimary isSmall isFull" @click="openDialogCourse(item)"> 查看適用項目 </BaseButton>
      </div>
    </div>
    <DialogApplicableEvents :visible.sync="isDialogApplicableEventsVisible" :list="dialogApplicableEventList" />
  </div>
</template>


<style lang="scss" module>
.memberCouponItem {
  padding-right: 21px;
  padding-left: 21px;

  @include max-md {
    padding-right: 0;
    padding-left: 0;
  }

  :global {
    .badge {
      width: 88px;
    }

    .memberCouponItem {
      &__Btn {
        padding-left: 55px;
        @include max-md {
          padding-left: 0;
          color: $color-primary;
          font-size: 0.75rem;
          align-self: flex-start;
          &:hover:not(:disabled) {
            border-color: transparent;
          }
        }
      }
    }
  }
}
</style>
